import { ApiResult, httpRequest, Urls } from './Shared';

const PROPERTY_FAQS_URL = `${Urls.BASE_URL}/PropertyFaqs`;

export interface PropertyFaqUpdate {
    questionText: string;
    answerText: string;
}

export interface PropertyFaq extends PropertyFaqUpdate {
    id: number;
}

export interface PropertyFaqToggle {
    enabled: boolean;
}

export const getPropertyFaqs = (propertyId: number): Promise<ApiResult<PropertyFaq[]>> => {
    return httpRequest<PropertyFaq[]>(`${PROPERTY_FAQS_URL}/${propertyId}/FAQs`, 'get');
};

export const getPropertyFaqsBySlug = (slug: string): Promise<ApiResult<PropertyFaq[]>> => {
    return httpRequest<PropertyFaq[]>(`${PROPERTY_FAQS_URL}/${slug}`, 'get');
};

export const addPropertyFaq = (
    propertyId: number,
    propertyFaq: PropertyFaqUpdate
): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(`${PROPERTY_FAQS_URL}/${propertyId}/FAQs`, 'post', propertyFaq);
};

export const updatePropertyFaq = (
    propertyId: number,
    faqId: number,
    propertyFaq: PropertyFaqUpdate
): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(
        `${PROPERTY_FAQS_URL}/${propertyId}/FAQs/${faqId}`,
        'put',
        propertyFaq
    );
};

export const deletePropertyFaq = (
    propertyId: number,
    faqId: number
): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(`${PROPERTY_FAQS_URL}/${propertyId}/FAQs/${faqId}`, 'delete');
};

export const togglePropertyFaqs = (
    propertyId: number,
    enabled: PropertyFaqToggle
): Promise<ApiResult<boolean>> => {
    return httpRequest<boolean>(`${PROPERTY_FAQS_URL}/${propertyId}/FAQs/toggle`, 'post', enabled);
};



// WEBPACK FOOTER //
// ./src/api/PropertyFaqs.ts